import React, { useState, useEffect, useRef } from 'react';
import { CommonSvgContent } from "./CommonSvgContent"

export const Player = (props) => {
  const audioElem = useRef();
  const soundMusic = require('../assets/mp3/sound.mp3');
  const endMusic = require('../assets/mp3/end2.mp3');


  let [state, setState] = React.useState({
    volume: true,
    currentSong: soundMusic,
    isplaying: false,
    button: false
  })

  const playSound = () => {
    audioElem.current.loop = true;
    audioElem.current.play();
    props.onChangeStep();

    setState(prevState => ({
      ...prevState,
      isplaying: 'sound',
      button: false
    }));
  }

  const showButton = () => {
    setState(prevState => ({
      ...prevState,
      button: true
    }));
  }

  const setCurrentSong = (toplay) => {
    if (toplay === 'sound'){
      audioElem.current.pause();
      setState(prevState => ({
        ...prevState,
        currentSong: soundMusic
      }));

      audioElem.current.load();
      audioElem.current.loop = false;
      audioElem.current.currentTime = 0;
    }
    else if(state.isplaying != 'end' && toplay === 'end'){

      audioElem.current.pause();
      setState(prevState => ({
        ...prevState,
        currentSong: endMusic,
        isplaying: toplay
      }));

      audioElem.current.load();
      audioElem.current.loop = false;
      audioElem.current.currentTime = 0;
      setTimeout(function () {
         console.log("audioElem.current: ",audioElem.current);
         audioElem.current.play();
      }, 1000);

    }
    else if(!toplay){
      audioElem.current.pause();
    }
  }




  // const PlayPause = ()=>
  // {
  //   if (state.isplaying != false) state.setisplaying(false);
  // }

  // const skipBack = ()=>{
  //   setCurrentSong("end");
  // }

  const toggleVol = () => {
    setState(prevState => ({
      ...prevState,
      volume: !state.volume
    }));
  }


  // const skiptoNext = ()=>{
  //   setCurrentSong("sound");
  // }

  useEffect(() => {
    if(props.room >= 1 && props.room <= 6){
      if(props.room === 1 && props.step === 0){
        setCurrentSong("sound");
        showButton();
      }
      else{

      }
    }
    else if(props.room == 7 || props.room == 8) setCurrentSong("end");
    else setCurrentSong(false);
  }, [props.room])

  useEffect(() => {
    if (state.currentSong){
      if(state.volume){
        audioElem.current.volume = 0.2;
        console.log(state.volume, " > 0.3");
      }
      else{
        audioElem.current.volume = 0.0;
        console.log(state.volume, " > 0.01");
      }
    }
    },[state.volume]
  );

  // useEffect(() => {
  //   if (isplaying) {
  //     audioElem.current.play();
  //   }
  //   else {
  //     audioElem.current.pause();
  //   }
  // }, [isplaying])

  return (
    <>

    <audio loop src={state.currentSong} ref={audioElem} />
    {(state.button) && (
      <div className="bigButton" onClick={(e) => playSound()}></div>
    )}


    {(props.room > 0 && props.room < 7) && (
      <div className="header">
        {/*<button onClick={toggle}>{playing ? "Pause" : "Play"}</button>*/}
        <div className={`vol ${state.volume ? "active" : ""}`}>
          <span className="label"><CommonSvgContent stringToRet="voloff" /></span>
          <label className="switch">
            <input type="checkbox" defaultChecked={state.volume} onChange={toggleVol} />
            <span className="slider round"></span>
          </label>
          <span className="label"><CommonSvgContent stringToRet="volon" /></span>
        </div>
        {/*<button onClick={toggleVol}>{volume ? "Mute" : "Sound"}</button>*/}
      </div>
    )}

    {/*
    <div className='player_container'>
      <div className="controls">
        <button onClick={skipBack}>Back</button>
        <button onClick={PlayPause}>{state.isplaying ? "Pause" : "Play"}</button>
        <button onClick={skiptoNext}>Next</button>
      </div>
    </div>
    */}
    </>

  )
}
